<!-- eslint-disable max-len -->
<template>
  <div>
    <Card
      title="Music Categories"
    >
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="mr-2">
                <el-input placeholder="search category name" v-model="filter.q" @change="search" ></el-input>
              </div>
              <Button @clicked="search" label="Apply"/>
              <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="reset" /></button>
            </div>
            <Button @clicked="add" label="Add New Category" variant="outline-primary"/>
          </div>
        </div>

        <data-tables-server ref="tableCategories" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
          <el-table-column label="Actions" align="right" min-width="200px">
            <template v-slot="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="Detail" :position="'is-left'">
                  <button @click="edit(scope.row)" class="p-2 w-8 mr-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip label="Delete" :position="'is-left'">
                  <button @click="deleteCategory(scope.row)" class="w-8 mr-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
    <ModalDialog
      ref="addSong"
      :isShowingModal="isShowingModal"
      :title="titleModal"
      @toggleModal="toggleModal"
      :labelSubmit="'Submit'"
      @save="submitFormCategory()" >
      <template slot="body" >
        <CategoriesForm
          ref="categoriesForm"
          :toggle-reset="isShowingModal"
          :categories="selectedRow"
          @on-submit-category="onSubmitForm"
          :type-categories="typeCategories"
        />
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import Card from '@/components/Layout/Card';
import { Button } from '@/components/Layout/Form';
import CategoriesForm from './CategoriesForm';


const typeCategories = 'music';
const initialStateCategory = {
  id: null,
  name: '',
  cover: null,
};
export default {
  name: 'MusicCategoriesPage',
  data() {
    return {
      isLoading: false,
      isShowingModal: false,
      typeModal: 'add',
      data: [],
      total: 0,
      page: 1,
      titles: [{
        prop: {
          field: 'name',
          width: 'auto',
        },
        label: 'Categories',
      }],
      filter: {
        per_page: 20,
        page: 1,
        q: '',
        sortorder: 'desc',
        sortby: 'id',
      },
      selectedRow: { ...initialStateCategory },
      typeCategories,
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListCategories({ filter: this.filter, type: typeCategories });
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isFinance', 'isOps']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('CategoriesModule', ['listCategories', 'totalCategories']),
    titleModal() {
      return this.typeModal === 'add' ? 'Add Category' : 'Edit Category';
    },
  },
  watch: {
    listCategories: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('CategoriesModule', ['requestListCategories', 'requestDeleteCategories']),
    async search() {
      await this.requestListCategories({ filter: this.filter, type: typeCategories });
    },
    async reset() {
      this.$refs.tableCategories.$refs.elTable.clearSort();
      this.filter = {
        q: '',
        per_page: 20,
        page: 1,
        sortorder: 'desc',
        sortby: 'id',
      };
      this.search();
    },
    add() {
      this.selectedRow = { ...initialStateCategory };
      this.typeModal = 'add';
      this.toggleModal();
    },
    edit(row) {
      this.selectedRow = { ...row };
      this.typeModal = 'edit';
      this.toggleModal();
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
    },
    refineData() {
      if (this.listCategories) {
        this.total = this.totalCategories;
        this.data = this.listCategories;
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      this.displayingItem = queryInfo.pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter.sortorder = sortorder;
      this.filter.sortby = sortby;
      this.filter.page = page;
      await this.search();
    },
    async deleteCategory(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete category: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          const data = { id: row.id };
          await this.requestDeleteCategories({ data, filter: this.filter, type: typeCategories });
          if (this.getStatus === 200) {
            await this.search();
            this.$swal('Deleted', `You successfully delete category: ${row.name}`, 'success');
          } else if (this.getStatus !== 200 && this.getErrorCode === 'error-delete-categories') {
            this.$swal('Couldn’t Delete Category', this.getMessage, 'error');
          }
        }
      });
    },
    async onSubmitForm() {
      this.isShowingModal = false;
      await this.search();
    },
    async submitFormCategory() {
      await this.$refs.categoriesForm.submit();
    },
  },
  components: {
    ModalDialog,
    VueCustomTooltip,
    CategoriesForm,
    Card,
    Button,
  },
};
</script>
<style scoped>
.el-table{
  min-height: 400px;
}

</style>



// WEBPACK FOOTER //
// src/views/Categories/MusicCategories.vue